import React, {useState} from "react";
import {Modal, Input, Button, Form, message} from "antd";
import {useTranslation} from "react-i18next";

export const QueueIdModal = ({visible, onCancel, onConfirm, initialValue}) => {
    const [loading, setLoading] = useState(false);
    const [queueId, setQueueId] = useState(initialValue || "");
    const {t} = useTranslation(["common"]);

    const handleConfirm = async () => {
        if (!queueId || isNaN(queueId) || parseInt(queueId) <= 0) {
            message.error("Lütfen geçerli bir kuyruk ID girin (pozitif sayı)");
            return;
        }

        setLoading(true);
        try {
            await onConfirm(parseInt(queueId));
            setQueueId("");
        } catch (error) {
            console.error("Queue ID confirmation error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setQueueId(initialValue || "");
        onCancel();
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        // Only allow numeric input
        if (value === "" || /^\d+$/.test(value)) {
            setQueueId(value);
        }
    };

    return (
        <Modal
            title="AloTech Kuyruk ID Seçimi"
            visible={visible}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    İptal
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    loading={loading}
                    onClick={handleConfirm}
                    disabled={!queueId || isNaN(queueId) || parseInt(queueId) <= 0}
                >
                    Onayla
                </Button>
            ]}
            width={400}
            destroyOnClose={true}
        >
            <div style={{marginBottom: 16}}>
                <p>
                    Kurye arama özelliği aktif edildi. Lütfen AloTech sisteminde kullanılacak kuyruk ID'sini girin.
                </p>
            </div>
            
            <Form layout="vertical">
                <Form.Item
                    label="Kuyruk ID"
                    required
                    help="AloTech sistemindeki kuyruk ID'sini girin (pozitif sayı)"
                >
                    <Input
                        placeholder="Örn: 123"
                        value={queueId}
                        onChange={handleInputChange}
                        type="text"
                        maxLength={10}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}; 